import { Button, Col, message, Row, Select } from "antd";
import { ReactNode, useEffect, useState } from "react";
import { getThemeSettingListApi } from "states/theme-setting/theme-setting.api";
import {
  CustomThemeModel,
  ThemeSettingModel,
} from "states/theme-setting/theme-setting.models";
import {
  convertToThemeTemplateItem,
  setValueFromTemplate,
} from "states/theme-setting/theme-setting.services";
import { getThemeTemplateList } from "states/theme-template/theme-template.api";
import { ThemeTemplateModel } from "states/theme-template/theme-template.models";
import { ThemeSettingGroup } from "./theme-setting-group";

export interface ICustomThemeProps {
  model: any;
  onChange: (changedModel: any) => void;
}

export function CustomTheme(props: ICustomThemeProps) {
  const { model, onChange } = props;
  const [themeTemplateList, setThemeTemplateList] = useState<
    ThemeTemplateModel[]
  >([]);
  const [themeSettingList, setThemeSettingList] = useState<ThemeSettingModel[]>(
    []
  );
  const [currentTemplate, setCurrentTemplate] = useState<ThemeTemplateModel>();

  const _handleChangeTemplate = (value: string) => {
    const template = themeTemplateList.find((m) => m.id === value);
    if (!template) return;
    setCurrentTemplate({ ...template });
  };

  const _handleAddTemplate = () => {
    if (!currentTemplate) {
      message.error("Please select tempalte");
      return;
    }
    if (model[currentTemplate.slug]) {
      message.error("Element already exists");
      return;
    }

    const templateItem = convertToThemeTemplateItem(currentTemplate);
    model[currentTemplate.slug] = {
      themeId: undefined,
      customValue: setValueFromTemplate(templateItem),
      templateId: currentTemplate.id,
    } as CustomThemeModel;
    onChange(model);
  };

  const _handleRenderCustomTheme = () => {
    const nodeList: ReactNode[] = [];
    for (let propName in model) {
      const template = themeTemplateList.find(
        (m) => m.id === model[propName].templateId
      );
      if (!template) {
        continue;
      }
      nodeList.push(
        <ThemeSettingGroup
          template={convertToThemeTemplateItem(template)}
          themeSettingList={themeSettingList.filter(
            (setting) => setting.themeTemplateId === template.id
          )}
          itemKey={template.slug}
          model={model[propName].customValue}
          onChange={(changedModel) => {
            model[propName].customValue = changedModel;
            onChange(model);
          }}
          onChangeThemeSettingId={(themeId) => {
            model[propName].themeId = themeId;
            onChange(model);
          }}
          themeSettingId={model[propName].themeId}
          className="mb-4"
          onDelete={() => {
            delete model[propName];
            onChange(model);
          }}
        ></ThemeSettingGroup>
      );
    }
    return nodeList;
  };

  useEffect(() => {
    getThemeTemplateList().then((res) => {
      setThemeTemplateList(res.data);
    });

    getThemeSettingListApi().then((res) => {
      setThemeSettingList(res.data);
    });
  }, []);

  return themeTemplateList.length > 0 ? (
    <Row gutter={[16, 16]} className="mb-4">
      <Col span={8}>
        <Select
          className="w-100"
          placeholder="Select template"
          value={currentTemplate?.id}
          onChange={_handleChangeTemplate}
          showSearch
          filterOption={(input, option: any) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {themeTemplateList.map((template) => (
            <Select.Option value={template.id ? template.id : ""}>
              {template.name}
            </Select.Option>
          ))}
        </Select>
      </Col>
      <Col span={8}>
        <Button onClick={_handleAddTemplate}>Add theme</Button>
      </Col>
      <Col span={24}>{_handleRenderCustomTheme()}</Col>
    </Row>
  ) : null;
}
